export enum AsecurityCreationError {
    NAME_CONTAINS_COLON             = 'NAME_CONTAINS_COLON',
    NAME_EXISTS                     = 'NAME_EXISTS',
    PAY_UP_IS_INVALID               = 'PAY_UP_IS_INVALID',
    PAY_UP_IS_NOT_ALLOWED           = 'PAY_UP_IS_NOT_ALLOWED',
    PRICE_RATIO_IS_INVALID          = 'PRICE_RATIO_IS_INVALID',
    PRIVATE_EXCHANGE_IS_UNSUPPORTED = 'PRIVATE_EXCHANGE_IS_UNSUPPORTED',
    QTY_RATIO_IS_INVALID            = 'QTY_RATIO_IS_INVALID',
    SECURITY_KEY_DUPLICATE          = 'SECURITY_KEY_DUPLICATE',
    SECURITY_KEY_IS_INVALID         = 'SECURITY_KEY_IS_INVALID',
    STOP_TIMEOUT_IS_INVALID         = 'STOP_TIMEOUT_IS_INVALID',
    STOP_TIMEOUT_IS_NOT_ALLOWED     = 'STOP_TIMEOUT_IS_NOT_ALLOWED',
    TWO_LEGS_ARE_REQUIRED           = 'TWO_LEGS_ARE_REQUIRED'
}

export const ASECURITY_CREATION_ERROR_L10N_DICT: Record<AsecurityCreationError, string> = {
    [AsecurityCreationError.NAME_CONTAINS_COLON]:
        'components.autospreader.security_error_name_contains_colon',
    [AsecurityCreationError.NAME_EXISTS]:
        'components.autospreader.security_error_name_exists',
    [AsecurityCreationError.PAY_UP_IS_INVALID]:
        'components.autospreader.security_error_pay_up_is_invalid',
    [AsecurityCreationError.PAY_UP_IS_NOT_ALLOWED]:
        'components.autospreader.security_error_pay_up_is_not_allowed',
    [AsecurityCreationError.PRICE_RATIO_IS_INVALID]:
        'components.autospreader.security_error_price_ratio_is_invalid',
    [AsecurityCreationError.PRIVATE_EXCHANGE_IS_UNSUPPORTED]:
        'components.autospreader.security_error_private_exchange_is_unsupported',
    [AsecurityCreationError.QTY_RATIO_IS_INVALID]:
        'components.autospreader.security_error_qty_ratio_is_invalid',
    [AsecurityCreationError.SECURITY_KEY_DUPLICATE]:
        'components.autospreader.security_error_security_key_duplicate',
    [AsecurityCreationError.SECURITY_KEY_IS_INVALID]:
        'components.autospreader.security_error_security_key_is_invalid',
    [AsecurityCreationError.STOP_TIMEOUT_IS_INVALID]:
        'components.autospreader.security_error_stop_timeout_is_invalid',
    [AsecurityCreationError.STOP_TIMEOUT_IS_NOT_ALLOWED]:
        'components.autospreader.security_error_stop_timeout_is_not_allowed',
    [AsecurityCreationError.TWO_LEGS_ARE_REQUIRED]:
        'components.autospreader.security_error_two_legs_are_required'
};
